import styled, { css } from 'styled-components'
import posed from 'react-pose'

export const TabsStyled = styled.div`
`

const StyledTabsHeaderPosed = posed.div({
    hidden: { height: '0px' },
    visible: { height: '39px' }
});

export const StyledTabsHeader = styled(StyledTabsHeaderPosed)`
    position: relative;
    background-color: ${ ({ theme }) => theme.whiteTwo};
    margin-bottom: 10px;
    height: 39px;
    overflow: hidden;
    &:before {
        content: '';
        position: absolute;
        top: auto;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: ${({ theme }) => theme.veryLightPink};
    }
`

export const StyledTabsContent = styled.div`
    transition: all 3s;
`

export const TabsWrraperStyled = styled.div`
    display: flex;
    justify-content: center;
`

export const TabStyled = styled.div`
    flex: 1;
    min-width: 85px;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    font-weight: 400;
    padding-top: 12px;
    padding-bottom: 12px;
    transition: all 0.3s;
    cursor: pointer;
    ${({ isActive }) =>
        isActive &&
        css`
           color: ${({ theme }) => theme.grassyGreen};
           font-weight: 900;
        `
    };
`

export const IndicatorStyled = styled.div`
    width: ${({ quantity }) => `calc(100% / ${quantity})`};
    height: 2px;
    background-color: ${({ theme }) => theme.grassyGreen};
    transform: ${({ value }) => `translateX(${100 * value}%)`};
    transition: transform 0.3s;
`